<template>
  <div class="print-all-invoices">
    <div
      v-if="isLoading"
      class="text-center"
    >
      <b-spinner variant="primary" />
      <p>Chargement des factures...</p>
    </div>

    <div
      v-else
      class="invoices-container"
    >
      <!-- Each invoice on a separate page when printing -->
      <div
        v-for="(invoice, index) in invoices"
        :key="invoice.id"
        :class="['invoice-page', { 'page-break': index < invoices.length - 1 }]"
      >
        <!-- Invoice content (copied from Show.vue structure) -->
        <div class="invoice-preview-card">
          <!-- Header -->
          <div class="d-flex justify-content-center flex-md-row flex-column invoice-spacing mt-0">
            <div style="color: black">
              <div class="logo-wrapper">
                <brand-logo
                  width="250px"
                  height="100%"
                />
              </div>
            </div>
          </div>

          <div class="d-flex flex-row justify-content-between">
            <div class="ml-3">
              <h1 style="color: black; font-size: 30px">
                Facture
              </h1>
            </div>
            <div>
              <h3
                class="mr-3"
                style="color: black"
              >
                Date: <span style="color: black">{{ formatDate(invoice.created_at) }}</span>
              </h3>
            </div>
          </div>

          <!-- Company and Supplier Info -->
          <div class="d-flex flex-row justify-content-between p-3">
            <div
              class="mb-2 mt-0 ml-2"
              style="border: 2px solid black; padding: 10px;"
            >
              <div class="ml-2 mr-2 mt-2 mb-1 h4 text-dark font-weight-bold">
                <strong>{{ company.name }} :</strong> {{ company.tagline || 'Société de livraison des colis' }}
              </div>
              <div class="ml-2 h4 text-dark font-weight-bold mr-2 mb-1">
                <strong>Matricule fiscale :</strong> {{ company.tax_identification_number }}
              </div>
              <div class="ml-2 mr-2 mb-1 h4 text-dark font-weight-bold">
                <strong>Adresse :</strong> {{ company.address }}
              </div>
              <div class="ml-2 mr-2 mb-1 h4 text-dark font-weight-bold">
                <strong>Tel :</strong> {{ company.phone1 }}
              </div>
            </div>

            <div
              class="mb-2 mt-0 ml-2"
              style="border: 2px solid black; padding: 10px;"
            >
              <div class="ml-2 mr-2 mt-2 mb-1 h4 text-dark font-weight-bold">
                <strong>Fournisseur :</strong> {{ invoice.supplier.username }}
              </div>
              <div class="ml-2 h4 text-dark font-weight-bold mr-2 mb-1">
                <strong>Matricule fiscale :</strong> {{ invoice.supplier.tax_identification_number }}
              </div>
              <div class="ml-2 mr-2 mb-1 h4 text-dark font-weight-bold">
                <strong>Adresse :</strong> {{ invoice.supplier.address }}
              </div>
              <div class="ml-2 mr-2 mb-1 h4 text-dark font-weight-bold">
                <strong>Tel :</strong> {{ invoice.supplier.phone }}
              </div>
            </div>
          </div>

          <!-- Summary Table -->
          <div class="p-3">
            <table style="border: 2px solid black; width: 100%;">
              <tr>
                <th>Nombre de colis</th>
                <th>Colis livré</th>
                <th>Colis retour</th>
                <th>Total COD</th>
                <th>Frais de livraison</th>
                <th>Net a payer</th>
              </tr>
              <tr>
                <td>{{ invoice.total_nb }}</td>
                <td>{{ invoice.nb_delivered }}</td>
                <td>{{ invoice.nb_return }}</td>
                <td>{{ invoice.total_ttc }}</td>
                <td>{{ invoice.total_delivery }}</td>
                <td>{{ invoice.total }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import axios from 'axios'
import storeAuth from '@/store/store'

export default {
  name: 'PrintAllInvoices',
  components: {
    BSpinner,
  },
  data() {
    return {
      invoices: [],
      company: {},
      isLoading: true,
    }
  },
  async created() {
    this.company = storeAuth.state.company
    await this.loadInvoices()
  },
  methods: {
    async loadInvoices() {
      const invoiceIds = this.$route.query.ids ? this.$route.query.ids.split(',') : []

      if (!invoiceIds || invoiceIds.length === 0) {
        this.$router.push({ name: 'invoice-list' })
        return
      }

      this.isLoading = true

      try {
        // Fetch all invoices
        const promises = invoiceIds.map(id => axios.get(`/api/invoices/detail/${id}/`))
        const responses = await Promise.all(promises)
        this.invoices = responses.map(res => res.data)

        // Auto-print after loading
        this.$nextTick(() => {
          setTimeout(() => {
            window.print()
          }, 500)
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading invoices:', error)
      } finally {
        this.isLoading = false
      }
    },

    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString('fr-FR')
    },
  },
}
</script>

<style lang="scss" scoped>
.invoice-page {
  padding: 20px;
  background: white;
}

.page-break {
  page-break-after: always;
}

table {
  border-collapse: collapse;

  th, td {
    border: 1px solid black;
    padding: 10px;
    text-align: left;
  }
}

@media print {
  .invoice-page {
    padding: 0;
  }

  .page-break {
    page-break-after: always;
  }
}
</style>
